/**
 * Copyright (c) 2021-2024 Kognitos, Inc. All rights reserved.
 */
import { useSelector } from 'react-redux';
import { drawerSelector } from '../stores/slices/appDrawer';

function CurrentDrawer() {
  const { currentDrawerId } = useSelector(drawerSelector);

  switch (currentDrawerId) {
    default:
      return null;
  }
}

export default CurrentDrawer;
